
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
  font-family: var(--ff-display);
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* unset browser defaults for headings and p */
:host:is(h1,h2,h3,h4,h5,h6,p),
h1,h2,h3,h4,h5,h6 {
  all: unset;
}
/* Image reset */
img {
  max-width: 100%;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
.sr-only,
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
:host{
  display:block;
}

.body{
  padding-top:var(--spacing-02);
  padding-top:var(
    --sic-global-alert--default--xsmall-spacing,
    var(--spacing-02)
  );
}

.container{
  padding-block:var(--spacing-04);
  padding-block:var(
    --sic-global-alert--default--small-spacing,
    var(--spacing-04)
  );
  display:grid;
  justify-content:space-between;
}

@media (min-width: 768px){

.container{
    display:flex
}
  }

.is-inpage{
  padding-top:var(--sic-global-alert--default--xsmall-spacing);
  padding-top:var(
    --sic-global-alert--xsmall-spacing,
    var(--sic-global-alert--default--xsmall-spacing)
  );
  padding-bottom:var(--sic-global-alert--default--xsmall-spacing);
  padding-bottom:var(
    --sic-global-alert--xsmall-spacing,
    var(--sic-global-alert--default--xsmall-spacing)
  );
  padding-left:var(--sic-global-alert--default--medium-spacing);
  padding-left:var(
    --sic-global-alert--medium-spacing,
    var(--sic-global-alert--default--medium-spacing)
  );
  padding-right:var(--sic-global-alert--default--large-spacing);
  padding-right:var(
    --sic-global-alert--large-spacing,
    var(--sic-global-alert--default--large-spacing)
  );
  display:grid;
  justify-content:space-between;
}

@media (min-width: 768px){

.is-inpage{
    display:flex
}
  }

.is-inpage .body{
    padding:var(--spacing-02) 0;
    padding:var(--sic-global-alert--default--xsmall-spacing, var(--spacing-02)) 0;
  }

.content{
  display:flex;
  flex:2 1fr;
  align-items:center;
  gap:var(--grid-gap);
}

.content .icon{
    margin:auto;
  }

.closing-wrapper{
  display:flex;
  justify-content:flex-end;
}

.has-right-content{
  display:flex;
  justify-content:space-between;
  flex:1;
}

.success{
  background-color:var(--color-system-success-lightest);
}

.success .icon{
    color:var(--color-system-success-darkest);
  }

.info{
  background-color:var(--color-system-info-lightest);
}

.info .icon{
    color:var(--color-system-info-darkest);
  }

.error{
  background-color:var(--color-system-error-lightest);
}

.error .icon{
    color:var(--color-system-error-darkest);
  }

.warning{
  background-color:var(--color-system-warning-lightest);
}

.warning .icon{
    color:var(--color-system-warning-darkest);
  }

.closing{
  display:flex;
  justify-content:flex-end;
}

.mobile-icons{
  display:grid;
  grid-template-columns:repeat(2, 1fr);
  grid-template-rows:1fr;
  grid-column-gap:0px;
  grid-row-gap:0px;
  padding-bottom:var(--spacing-08);
  padding-bottom:var(
    --sic-global-alert--default--large-spacing,
    var(--spacing-08)
  );
}
`;